import R from 'ramda';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getWorkTypeNameById,
  getSubWorkTypeNameById,
  getMemberByUserId,
} from '../../utils';
import AgreementSection from './AgreementSection';
import { selectDealBlocksState } from '../../redux/selectors';
import getContent from '../ContractBlock/Contents';
import getState from '../Deals/DealEditPages/helpers/getState';

class AgreementTextProducer extends Component {
  renderWorkRow(work, i) {
    const { workTypes, subWorkTypes, type } = this.props;
    let workTypeName = '';
    let subWorkTypeName = '';

    if (type === 'agreement-detail' && !work.date_accepted) {
      return null;
    }

    if (work.type) {
      workTypeName = getWorkTypeNameById(work.type, workTypes);
    }
    if (work.sub_type) {
      subWorkTypeName = getSubWorkTypeNameById(work.sub_type, subWorkTypes);
    }

    return (
      <tr key={i}>
        <td>{work.name}</td>
        <td>
          {workTypeName}, {subWorkTypeName}
        </td>
        <td>{moment(work.date_created).format('MM/DD/YYYY')}</td>
      </tr>
    );
  }

  renderCreateWorkRow() {
    const { fields, workTypes, subWorkTypes, type } = this.props;
    let workTypeName = '';
    let subWorkTypeName = '';

    if (type === 'create') {
      if (fields.type) {
        workTypeName = getWorkTypeNameById(fields.type, workTypes);
      }
      if (fields.subtype) {
        subWorkTypeName = getSubWorkTypeNameById(fields.subtype, subWorkTypes);
      }

      return (
        <tr>
          <td>{fields.name}</td>
          <td>
            {workTypeName}, {subWorkTypeName}
          </td>
          <td>{moment().format('MM/DD/YYYY')}</td>
        </tr>
      );
    }
  }

  renderWorks() {
    const { works, type } = this.props;

    if (type === 'create' || (works && works.length)) {
      return (
        <div className="user-status">
          <table>
            <thead>
              <tr>
                <th>Work</th>
                <th>Type of Work</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {works && works.length
                ? works.map((work, i) => this.renderWorkRow(work, i))
                : null}
              {this.renderCreateWorkRow()}
            </tbody>
          </table>
        </div>
      );
    }
  }

  loadAgreementText() {
    const {
      contractBlocks,
      type,
      agreement,
      agreementContractBlocks,
      works,
      dealBlocks,
      members,
      dealUsers,
      isTestVersion,
    } = this.props;

    let dateEffect = moment().format('dddd, MMMM Do, YYYY');
    if (type !== 'create') {
      dateEffect = moment(agreement.date_created).format('dddd, MMMM Do, YYYY');
    }

    let sigUsers = [];
    let ownerships = [];

    if (works.length) {
      ownerships = works[0].work_ownership_info || [];
    }

    if (type !== 'create') {
      dealUsers.forEach((dealUser) => {
        if (dealUser.status === 'Accepted') {
          const invitee = this.props.invites.find(
            (invite) => invite.invitee === dealUser.user
          );
          const member = getMemberByUserId(dealUser.user, members);
          let userInfo = {};

          if (member && member.user_info) {
            const user = member.user_info;
            const ownership = R.find(R.propEq('user', dealUser.user))(
              ownerships
            );

            if (ownership) {
              if (agreement.completed) {
                userInfo = {
                  ...ownership,
                  // name: invitee.name,
                  // address: user.address,
                  // city: user.city,
                  // state: user.state,
                  // postal: user.postal,
                  // country: user.country
                  email: user.email,
                  name: ownership.name === '' ? invitee.name : ownership.name,
                  address:
                    ownership.address === '' ? user.address : ownership.address,
                  city: ownership.city === '' ? user.city : ownership.city,
                  state: ownership.state === '' ? user.state : ownership.state,
                  postal:
                    ownership.postal === '' ? user.postal : ownership.postal,
                  country:
                    ownership.country === '' ? user.country : ownership.country,
                };
              } else {
                userInfo = {
                  use_company_name: ownership.use_company_name,
                  company_name: ownership.company_name,
                  user_title: ownership.user_title,
                  email: user.email,
                  name: invitee.name,
                  address: user.address,
                  city: user.city,
                  state: user.state,
                  postal: user.postal,
                  country: user.country,
                };
              }
            }

            sigUsers.push({
              user,
              dealUser,
              ...userInfo,
            });
          }
        }
      });
    }

    const options = {
      dateEffect,
      sigUsers,
      hasWork: type === 'create' || (works && works.length),
    };

    if (contractBlocks.length) {
      contractBlocks.forEach((block, i) => {
        let content = block.content || '';
        let changeOptions = block.options;

        if (type !== 'create' && agreementContractBlocks) {
          let index = R.findIndex(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          if (index !== -1) {
            content = agreementContractBlocks[index].content;
            changeOptions = JSON.parse(agreementContractBlocks[index].options);
          }
        }

        if (type === 'deal-edit' && dealBlocks && isTestVersion) {
          let index = R.findIndex(R.propEq('id', block.id))(dealBlocks);
          if (index !== -1 && dealBlocks[index].changes) {
            const blockContent = getContent(
              block.name,
              dealBlocks[index].changes,
              {
                type: agreement.type,
                state: getState(
                  !isTestVersion,
                  contractBlocks,
                  agreementContractBlocks,
                  dealBlocks
                ),
              }
            );
            content = blockContent.content;
            changeOptions = dealBlocks[index].changes;
          }
        }

        if (
          block.name === 'Dispute Resolution' &&
          changeOptions &&
          isTestVersion
        ) {
          const blockContent = getContent(block.name, changeOptions, {
            state: getState(
              !isTestVersion,
              contractBlocks,
              agreementContractBlocks,
              dealBlocks
            ),
          });
          content = blockContent.content;
        }

        if (block.name === 'Services') {
          options['producer'] = '[PRODUCER]';
          options['producer_address'] = '';
          options['owner'] = '[OWNER]';
          options['owner_address'] = '';

          if (type === 'create') {
            options['masters'] = block.options
              ? block.options.masters || ''
              : '';
            options['artistName'] = block.options
              ? block.options.artistName || ''
              : '';
          } else {
            options['masters'] = changeOptions
              ? changeOptions.masters || ''
              : '';
            options['artistName'] = changeOptions
              ? changeOptions.artistName || ''
              : '';
          }

          if (changeOptions && changeOptions.producer) {
            if (type === 'create') {
              const member = getMemberByUserId(changeOptions.producer, members);
              if (member && member.user_info) {
                const producer = member.user_info;
                let producerName = producer.name;
                producerName =
                  producer.use_company_name && producer.company_name
                    ? producer.company_name
                    : producer.name;
                options['producer'] = producerName;
                options[
                  'producer_address'
                ] = `${producer['address']}, ${producer['city']}, ${producer['state']} ${producer['postal']}`;
              }

              const nonProducers = R.filter(
                (member) =>
                  member.user !== parseInt(changeOptions.producer, 10),
                members
              );
              if (nonProducers.length) {
                const owner = nonProducers[0].user_info;
                let ownerName = owner.name;
                ownerName =
                  owner.use_company_name && owner.company_name
                    ? owner.company_name
                    : ownerName;
                options['owner'] = ownerName;
                options[
                  'owner_address'
                ] = `${owner['address']}, ${owner['city']}, ${owner['state']} ${owner['postal']}`;
              }
            } else if (dealUsers) {
              const member = getMemberByUserId(changeOptions.producer, members);

              if (member && member.user_info) {
                let producer = member.user_info;
                let producerName = producer.name;
                const ownership = R.find(
                  R.propEq('user', parseInt(changeOptions.producer, 10))
                )(ownerships);

                if (ownership) {
                  if (agreement.completed) {
                    producer = {
                      ...ownership,
                      // name: producer.name,
                      // address: producer.address,
                      // city: producer.city,
                      // state: producer.state,
                      // postal: producer.postal,
                      // country: producer.country
                      name:
                        ownership.name === '' ? producer.name : ownership.name,
                      address:
                        ownership.address === ''
                          ? producer.address
                          : ownership.address,
                      city:
                        ownership.city === '' ? producer.city : ownership.city,
                      state:
                        ownership.state === ''
                          ? producer.state
                          : ownership.state,
                      postal:
                        ownership.postal === ''
                          ? producer.postal
                          : ownership.postal,
                      country:
                        ownership.country === ''
                          ? producer.country
                          : ownership.country,
                    };
                  }
                  producerName =
                    producer.use_company_name && producer.company_name
                      ? producer.company_name
                      : producer.name;
                }
                options['producer'] = producerName;
                options[
                  'producer_address'
                ] = `${producer['address']}, ${producer['city']}, ${producer['state']} ${producer['postal']}`;
              }

              const nonProducers = R.filter(
                (dealUser) =>
                  dealUser.type === 'member' &&
                  dealUser.user !== parseInt(changeOptions.producer, 10),
                dealUsers
              );
              if (nonProducers.length) {
                const member = getMemberByUserId(nonProducers[0].user, members);

                if (member && member.user_info) {
                  let owner = member.user_info;
                  let ownerName = owner.name;
                  const ownership = R.find(
                    R.propEq('user', parseInt(owner.id, 10))
                  )(ownerships);

                  if (ownership) {
                    if (agreement.completed) {
                      owner = {
                        ...ownership,
                        // name: owner.name,
                        // address: owner.address,
                        // city: owner.city,
                        // state: owner.state,
                        // postal: owner.postal,
                        // country: owner.country
                        name:
                          ownership.name === '' ? owner.name : ownership.name,
                        address:
                          ownership.address === ''
                            ? owner.address
                            : ownership.address,
                        city:
                          ownership.city === '' ? owner.city : ownership.city,
                        state:
                          ownership.state === ''
                            ? owner.state
                            : ownership.state,
                        postal:
                          ownership.postal === ''
                            ? owner.postal
                            : ownership.postal,
                        country:
                          ownership.country === ''
                            ? owner.country
                            : ownership.country,
                      };
                    }
                    ownerName =
                      owner.use_company_name && owner.company_name
                        ? owner.company_name
                        : owner.name;
                  }
                  options['owner'] = ownerName;
                  options[
                    'owner_address'
                  ] = `${owner['address']}, ${owner['city']}, ${owner['state']} ${owner['postal']}`;
                }
              }
            }
          }
        }

        if (block.name === 'Ownership') {
          if (type === 'create') {
            options['composition'] = block.options
              ? block.options.composition
              : '';
            options['consent'] = block.options ? block.options.consent : '';
          } else {
            options['composition'] = changeOptions
              ? changeOptions.composition
              : '';
            options['consent'] = changeOptions ? changeOptions.consent : '';
          }
        }

        if (block.name === 'Payments' && type === 'create') {
          content = block.content || '';
        }

        options[block.name] = content;
      });
    }

    return this.renderTemplate(options);
  }

  getTagNumber = (paymentOptions) => {
    if (paymentOptions.paidType === undefined) {
      return '(a)';
    }
    if (paymentOptions.paidType === 0) {
      if (paymentOptions.feeType === undefined) {
        return '(a)';
      }
      return '(b)';
    } else if (paymentOptions.paidType === 1) {
      if (paymentOptions.feeType === undefined) {
        return '(a)';
      }
      if (
        paymentOptions.auditType === undefined ||
        paymentOptions.auditType === 'notWill'
      ) {
        return '(d)';
      }
      return '(e)';
    } else {
      if (
        paymentOptions.auditType === undefined ||
        paymentOptions.auditType === 'notWill'
      ) {
        return '(d)';
      }
      return '(e)';
    }
  };

  renderTemplate = (options) => {
    const propsData = {
      ...this.props,
      completed: this.props.agreement && this.props.agreement.completed,
    };
    const paymentOptions = _.find(
      this.props.contractBlocks,
      (block) => block.name === 'Payments'
    )['options'];
    const serviceContent =
      options['Services'] ||
      `<u>select services</u> services for <u>number of masters</u> master(s) performed by <u>artist name</u>.`;

    return (
      <div>
        <p>
          THIS PRODUCER AGREEMENT (the “Agreement”) is entered into on{' '}
          {options['dateEffect']} by and between&nbsp;
          {options['owner']} (Owner), having an address at{' '}
          {options['owner_address']} and {options['producer']} (Producer),&nbsp;
          having an address at {options['producer_address']}.
        </p>
        <p>
          This Agreement sets forth the basic understanding between Owner and
          Producer with respect to Producer rendering&nbsp;
          <span
            className="placeholder-text"
            dangerouslySetInnerHTML={{ __html: serviceContent }}
          ></span>{' '}
          in connection with master recording(s) (individually and collectively,
          including all tracks, multi-tracks and from the inception of recording
          thereof, the “Master(s)”).
        </p>
        <p>
          For good and valuable consideration, the receipt and sufficiency of
          which are hereby acknowledged, the parties hereby agree as follows:
        </p>

        <AgreementSection section="Services title" {...propsData}>
          {`<h5>1. Masters</h5>`}
        </AgreementSection>
        <AgreementSection section="Services" {...propsData}>
          {`Producer will produce ${
            options['masters'] ||
            '<span class="placeholder-text"><u>number of masters</u></span>'
          } Master(s) embodying the performance(s) of the recording artist ${
            options['artistName'] !== ''
              ? options['artistName']
              : '<span class="placeholder-text"><u>artist name</u></span>'
          } ("Artist") of certain musical composition(s) listed on Schedule A attached hereto and deemed incorporated herein by reference (the “Composition(s)”).  Owner shall be responsible for payment of all recording costs incurred in connection with each Master, subject to approval by Owner of such costs, including, without limitation, recording studio fees and musician fees.  Owner shall promptly reimburse Producer for all expenses incurred by Producer that Owner has approved (the “Expenses”).  Producer’s services hereunder are on a non-exclusive basis.`}
        </AgreementSection>

        <AgreementSection section="Payments title" {...propsData}>
          {propsData.type === 'create'
            ? `<h5 class="Payments">2. Payments</h5>`
            : `<h5>2. Payments</h5>`}
        </AgreementSection>
        <AgreementSection section="Payments" {...propsData}>
          {propsData.type === 'create'
            ? options['Payments'].split('<OWNERSHIP_OPTION>')[0]
            : options['Payments'].replace('<OWNERSHIP_OPTION>', '')}
        </AgreementSection>

        {propsData.type === 'create' &&
          paymentOptions &&
          options['composition'] === 0 && (
            <AgreementSection section="Composition" {...propsData}>
              {`${this.getTagNumber(
                paymentOptions
              )} <u>Compositions.</u><br /> ` +
                '<br />Producer warrants and represents that Producer has not made nor will make any contributions to the authorship of the Composition(s) or other materials recorded hereunder and shall not claim any right, title or interest therein.'}
            </AgreementSection>
          )}

        {propsData.type === 'create' &&
          paymentOptions &&
          options['composition'] === 1 && (
            <AgreementSection section="Composition" {...propsData}>
              {`${this.getTagNumber(
                paymentOptions
              )} <u>Publishing/Mechanical.</u><br /> ` +
                '<br />That portion of any Composition(s) written or co-written by the Producer hereunder is hereby and shall be licensed to Owner ' +
                `at ${
                  paymentOptions ? paymentOptions['statutoryPercentage'] : ''
                }% of the then current minimum statutory rate, subject to the accounting terms set forth in paragraph 2 above.  Owner and Producer acknowledge and agree that the percentages listed in Schedule B accurately set forth Producer’s share of all right, title and interest, including copyright, in and to the Composition(s).`}
            </AgreementSection>
          )}

        <AgreementSection section="Ownership title" {...propsData}>
          {`<h5>3. Ownership</h5>`}
        </AgreementSection>
        <AgreementSection section="Ownership" {...propsData}>
          {'As between Producer and Owner, all right, title and interest, including copyright, in and to the Master(s) and all work product, services, and materials provided by Producer in connection with this Agreement and the Master(s) are “works made for hire” for Owner under the U.S. Copyright Act.  ' +
            'To the extent Producer is deemed to have any ownership interest therein, Producer hereby irrevocably assigns all right, title and interest therein, including copyright, ' +
            'to Owner in perpetuity throughout the world and in all media now known or hereafter devised.  ' +
            `${
              options['consent'] === 0
                ? `Producer shall not distribute, display, reproduce, or otherwise make use of the Master(s), in whole or in part, in any manner or for any purpose without prior written consent from Owner.`
                : ''
            }` +
            `${
              options['consent'] === 1
                ? 'Producer may distribute, display, reproduce, or otherwise make use of the Master(s), in whole or in part, in any manner or for solely for promotional purposes.'
                : ''
            }`}
        </AgreementSection>

        <AgreementSection section="Credit title" {...propsData}>
          {propsData.type === 'create'
            ? `<h5 class="Credit;NameandLikeness">4. Credit; Name and Likeness</h5>`
            : `<h5>4. Credit; Name and Likeness</h5>`}
        </AgreementSection>
        <AgreementSection section="Credit;NameandLikeness" {...propsData}>
          {options['Credit; Name and Likeness']}
        </AgreementSection>

        <AgreementSection section="Governing Law title" {...propsData}>
          {propsData.type === 'create'
            ? `<h5 class="GoverningLaw">5. Governing Law</h5>`
            : `<h5>5. Governing Law</h5>`}
        </AgreementSection>
        <AgreementSection section="GoverningLaw" {...propsData}>
          {options['Governing Law']}
        </AgreementSection>

        <AgreementSection section="Notices title" {...propsData}>
          {`<h5>6. Notices</h5>`}
        </AgreementSection>
        <AgreementSection section="Notices" {...propsData}>
          Except as otherwise set forth in this Agreement, all notices that
          either of the Parties may desire to serve upon the other shall be in
          writing and may be served by personal delivery, electronic mail, or
          certified or registered mail addressed to the respective party at the
          address set forth on the first page hereof, or such other address as
          said party may from time to time designate in writing. The date of
          personal delivery, mailing, or email of such notice will be deemed the
          date of the serving said notice, statement or payment.
        </AgreementSection>

        <AgreementSection section="Dispute Resolution title" {...propsData}>
          {propsData.type === 'create'
            ? `<h5 class="DisputeResolution">7. Dispute Resolution</h5>`
            : `<h5>7. Dispute Resolution</h5>`}
        </AgreementSection>
        <AgreementSection section="DisputeResolution" {...propsData}>
          {options['Dispute Resolution']}
        </AgreementSection>

        <AgreementSection section="Waiver title" {...propsData}>
          {`<h5>8. Waiver</h5>`}
        </AgreementSection>
        <AgreementSection section="Waiver" {...propsData}>
          No term or provision of this Agreement shall be deemed waived and no
          breach excused unless such waiver or consent shall be in writing
          signed and dated by the Party claimed to have waived or consented.
        </AgreementSection>

        <AgreementSection section="Representations title" {...propsData}>
          {`<h5>9. Representations & Warranties; Indemninty</h5>`}
        </AgreementSection>
        <AgreementSection section="Representations" {...propsData}>
          {'(a) Producer represents, warrants, covenants, and agrees that:<br /><br />' +
            '(i) Producer is free to enter into and perform this Agreement, and is not and will not be under any disability, restriction or prohibition, contractual or otherwise, with respect to (A) Producer’s right to execute this agreement, (B) Producer’s right to grant all of the rights granted to Artist hereunder, and (C) Producer’s ability to fully perform each and every term and provision hereof; and <br /><br />' +
            '(ii)	No materials, ideas or other properties furnished by Producer and embodied or contained in or used in connection with the Masters (including, without limitation, Producer’s name and likeness and any so-called “samples”) or the packaging or advertising for phonograph records hereunder, shall violate any law or infringe upon any common law or statutory rights of any party, including, without limitation, contractual rights, copyrights and rights of privacy.  Without limiting the generality of the foregoing, Producer specifically represents and warrants that no selections recorded or to be recorded hereunder are subject to any re-recording restriction under any previous recording agreement to which Producer may have been a party.  Neither Producer nor any person engaged by Producer rendering services in connection with the Masters recorded hereunder is or will be a party to any contract which would in any way impair the rights granted hereunder.<br /><br />' +
            '(b) Owner represents, warrants, covenants, and agrees that Owner is free to enter into and perform this Agreement, and is not and will not be under any disability, restriction or prohibition, contractual or otherwise, with respect to Owner’s right to execute this agreement, and Owner’s ability to fully perform each and every term and provision hereof.<br /><br />' +
            '(c) Each party hereby indemnifies, saves, and holds the other party harmless from any and all loss and damage (including actual court costs and reasonable, outside  attorneys’ fees)  arising  out  of,  connected  with,  or  as  a  result  of  any inconsistency with, failure of, or breach or threatened breach by the indemnifying party of any warranty, representation, agreement, undertaking, or covenant contained in this Agreement including, without limitation, any claim by any third party in connection with the foregoing, provided such claim has been reduced to a final, adverse judgment by a court of competent jurisdiction or settled with Producer’s consent, which shall not be unreasonably withheld.'}
        </AgreementSection>

        <AgreementSection
          section="Relationship of the Parties title"
          {...propsData}
        >
          {`<h5>10. Relationship of the Parties</h5>`}
        </AgreementSection>
        <AgreementSection section="Relationship of the Parties" {...propsData}>
          The Parties shall have the relationship of independent contractors,
          and nothing in this Agreement shall be construed to place the Parties
          in the relationship of partners or joint venturers and neither party
          shall have the power to obligate or bind the other Party in any manner
          unless otherwise agreed in writing. Each party is solely responsible
          for filing all of its own tax returns, tax declarations and tax
          schedules and for the payment of all taxes (including without
          limitation social security taxes, federal, state and city income
          taxes, and sales and use taxes) required where due.
        </AgreementSection>

        <AgreementSection section="Additional Documents title" {...propsData}>
          {`<h5>11. Additional Documents</h5>`}
        </AgreementSection>
        <AgreementSection section="Additional Documents" {...propsData}>
          Each Party must execute all additional documents and take all actions
          as are reasonably requested by the other Parties in order to complete
          or confirm the transactions contemplated by this Agreement.
        </AgreementSection>

        <AgreementSection section="Reservation of Rights title" {...propsData}>
          {`<h5>12. Reservation of Rights</h5>`}
        </AgreementSection>
        <AgreementSection section="Reservation of Rights" {...propsData}>
          Any rights not expressly granted by a Party to this Agreement are
          reserved to that Party. Without limiting the foregoing, nothing in
          this Agreement shall be construed to prevent the Parties from creating
          a work not involving any other Party.
        </AgreementSection>

        <AgreementSection section="Successors and Assigns title" {...propsData}>
          {`<h5>13. Successors and Assigns</h5>`}
        </AgreementSection>
        <AgreementSection section="Successors and Assigns" {...propsData}>
          This Agreement shall be binding on any successors of the Parties. No
          Party shall have the right to assign its interests in or obligations
          under this Agreement to any other Party or third party, unless the
          prior written consent of the other Parties is obtained.
        </AgreementSection>

        <AgreementSection section="Entire Agreement title" {...propsData}>
          {`<h5>14. Entire Agreement</h5>`}
        </AgreementSection>
        <AgreementSection section="Entire Agreement" {...propsData}>
          This Agreement contains the entire understanding of the Parties
          relating to the subject matter herein contained and cannot be changed
          or terminated orally. Amendments to this Agreement shall be valid only
          if made in writing and agreed to by each of the Parties. This
          Agreement may be executed in counterparts, including by facsimile or
          other electronic means, each of which shall be deemed an original and
          all of which, when taken together, shall constitute one and the same
          instrument.
        </AgreementSection>

        <AgreementSection section="Section Headings title" {...propsData}>
          {`<h5>15. Section Headings</h5>`}
        </AgreementSection>
        <AgreementSection section="Section Headings" {...propsData}>
          Paragraph headings hereof are inserted only for the purpose of
          convenient reference. Such headings shall not be deemed to govern,
          limit, modify, or in any other manner affect the scope, meaning, or
          intent of the provisions of this Agreement, or any part or portion
          thereof, nor shall they otherwise be given any legal effect.
        </AgreementSection>

        <AgreementSection
          section="Severability of Invalid Provisions title"
          {...propsData}
        >
          {`<h5>16. Severability of Invalid Provisions</h5>`}
        </AgreementSection>
        <AgreementSection
          section="Severability of Invalid Provisions"
          {...propsData}
        >
          To the extent that any provision of this Agreement shall be determined
          to be invalid or unenforceable, the validity and enforceability of the
          remainder of such provision of this Agreement shall be unaffected. In
          the event any of the provisions are held invalid, illegal, or
          unenforceable, the Parties shall endeavor through good-faith
          negotiations to agree on a valid or enforceable provision which shall
          be a reasonable substitute in light of the tenor of the Agreement as
          originally executed and amended or modified form time to time prior to
          the determination of invalidity or unenforceability.
        </AgreementSection>

        <p>
          <b>
            Each Party hereby acknowledges and agrees that he or she has had the
            opportunity to consult with independent counsel of such Party’s own
            choice experienced in matters in connection with this Agreement,
            that any failure to do so is knowing and willful, and that this
            Agreement is the product of informed negotiation, and as such, shall
            not be construed against the drafter. Each Party further
            acknowledges and agrees that he or she has read and fully
            understands this Agreement, the contents hereof, and the legal
            consequences thereof.
          </b>
        </p>

        <p>
          IN WITNESS WHEREOF, the parties hereto have executed this Agreement on
          the day and year first above written.
        </p>

        {options['sigUsers'].map((sigUser, i) => {
          if (sigUser['use_company_name']) {
            return (
              <div className="sig-block" key={sigUser['dealUser']['id']}>
                <div className="deal-user-info">
                  <span className="deal-user-name">
                    <strong>{sigUser['company_name']}</strong>
                  </span>
                </div>
                <div className="sig-holder">
                  <img
                    src={sigUser['dealUser']['signature']}
                    role="presentation"
                  />
                </div>
                <div className="deal-user-info">
                  <span className="deal-user-name">
                    <strong>By {sigUser['name']}</strong>
                  </span>
                  <span className="deal-user-email">
                    It's {sigUser['user_title']}
                  </span>
                  <span className="deal-user-email">{sigUser['email']}</span>
                  <span className="deal-user-address">
                    {sigUser['address']}
                  </span>
                  <span className="deal-user-address">
                    {sigUser['city']
                      ? `${sigUser['city']}, ${sigUser['state']} ${sigUser['postal']}`
                      : `${sigUser['state']} ${sigUser['postal']}`}
                  </span>
                </div>
              </div>
            );
          } else {
            return (
              <div className="sig-block" key={sigUser['dealUser']['id']}>
                <div className="sig-holder">
                  <img
                    src={sigUser['dealUser']['signature']}
                    role="presentation"
                  />
                </div>
                <div className="deal-user-info">
                  <span className="deal-user-name">
                    <strong>{sigUser['name']}</strong>
                  </span>
                  <span className="deal-user-email">{sigUser['email']}</span>
                  <span className="deal-user-address">
                    {sigUser['address']}
                  </span>
                  <span className="deal-user-address">
                    {sigUser['city']
                      ? `${sigUser['city']}, ${sigUser['state']} ${sigUser['postal']}`
                      : `${sigUser['state']} ${sigUser['postal']}`}
                  </span>
                </div>
              </div>
            );
          }
        })}

        {options.hasWork && (
          <h4 className="subheading">
            <u>&nbsp;&nbsp;Schedule A – The Master(s)&nbsp;&nbsp;</u>
          </h4>
        )}

        {options.hasWork && (
          <p className="text-center">
            To the Agreement dated {options['dateEffect']}
            <br />
            Between {options['owner']} and {options['producer']}
          </p>
        )}
      </div>
    );
  };

  render() {
    const { works, contractBlocks, dealBlocks, type, isTestVersion } =
      this.props;
    const dates = [];
    let ownershipOptions = _.find(
      contractBlocks,
      (block) => block.name === 'Ownership'
    )['options'];

    if (type !== 'create' && isTestVersion) {
      const ownershipContractBlock = R.find(R.propEq('name', 'Ownership'))(
        contractBlocks
      );
      let block = R.find(R.propEq('id', ownershipContractBlock.id))(dealBlocks);
      if (block && block.changes) {
        ownershipOptions = block.changes;
      }
    }

    if (works.length) {
      works.forEach((work) => {
        if (work.date_accepted) {
          let dateEffect = moment(work.date_accepted).format('MMM/DD/YYYY');
          dates.push(dateEffect);
        }
      });
    }

    return (
      <div className="agreement-text">
        <div className="subheading">PRODUCER AGREEMENT</div>
        {this.loadAgreementText()}
        {this.renderWorks()}

        {ownershipOptions && ownershipOptions['composition'] === 1 && (
          <h4 className="subheading">
            <u>&nbsp;&nbsp;Schedule B – Split Sheets&nbsp;&nbsp;</u>
          </h4>
        )}
      </div>
    );
  }
}

AgreementTextProducer.defaultProps = {
  works: [],
  isTestVersion: true,
};

const mapStateToProps = (state, props) => ({
  profile: state.profile,
  fields: state.create.fields,
  roles: state.global.roles,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
  contractBlocks: state.global.contractBlocks,
  agreementContractBlocks: state.agreements.contractBlocks,
  dealBlocks: selectDealBlocksState(state, props),
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
});

export default connect(mapStateToProps)(AgreementTextProducer);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementTextProducer.jsx